import type { AnalyzePrintingsRow, PrintingStatus } from './types';

export const STALE_PRINTING_THRESHOLD_MS = 3 * 60 * 60 * 1000;

const isSuccess = (row: AnalyzePrintingsRow): boolean => {
  if (row.totalLines > 0 && row.currentLine >= row.totalLines) return true;
  return row.events.some((e) => e.eventType?.name === 'print-end');
};

const mostRecentEventTime = (row: AnalyzePrintingsRow): number => {
  let latest = 0;
  for (const e of row.events) {
    const t = Date.parse(e.createdAt);
    if (!Number.isNaN(t) && t > latest) latest = t;
  }
  return latest;
};

export const classifyPrinting = (row: AnalyzePrintingsRow): PrintingStatus => {
  if (isSuccess(row)) return 'success';
  if (row.endTime) return 'failure';
  const latest = mostRecentEventTime(row);
  const ageMs = Date.now() - latest;
  if (latest === 0 || ageMs > STALE_PRINTING_THRESHOLD_MS) return 'failure';
  return 'in-progress';
};
